import { render, staticRenderFns } from "./mapOrdersPopover.vue?vue&type=template&id=540b6194&scoped=true&"
import script from "./mapOrdersPopover.vue?vue&type=script&lang=js&"
export * from "./mapOrdersPopover.vue?vue&type=script&lang=js&"
import style0 from "./mapOrdersPopover.vue?vue&type=style&index=0&id=540b6194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b6194",
  null
  
)

export default component.exports